import { useCurrencyContext } from '@contexts/currency-context';
import { CAD_CURRENCY, CURRENCY_COOKIE, USD_CURRENCY } from '@utils/currency';
import { setCookie } from 'cookies-next';
import { useEffect, useState } from 'react';

export const CURRENCY_LIST = {
  [USD_CURRENCY]: {
    name: 'US dollar',
    slug: 'USD',
    flag: '/flags/usa.webp',
  },
  [CAD_CURRENCY]: {
    name: 'Canadian dollar',
    slug: 'CAD',
    flag: '/flags/canada.webp',
  },
};

export function useCurrencyDropdown(): [string, (currency: string) => void] {
  const { currency, setCurrency } = useCurrencyContext();
  const [isCadRateAvailable, setIsCadRateAvailable] = useState<boolean | null>(
    null
  );
  const TWO_MINUTES_IN_SECONDS = 120;

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json',
          {
            next: { revalidate: TWO_MINUTES_IN_SECONDS },
          }
        );
        const data = await res.json();

        setIsCadRateAvailable(data?.usd?.cad);
      } catch (e) {
        setIsCadRateAvailable(false);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    if (
      currency === CAD_CURRENCY &&
      isCadRateAvailable !== null &&
      !isCadRateAvailable
    ) {
      setCookie(CURRENCY_COOKIE, USD_CURRENCY, { maxAge: 60 * 60 * 24 * 30 });
      setCurrency(USD_CURRENCY);
    }
  }, [currency, isCadRateAvailable, setCurrency]);

  const selectCurrency = (selectedCurrency: string) => {
    setCookie(CURRENCY_COOKIE, selectedCurrency, { maxAge: 60 * 60 * 24 * 30 });
    setCurrency(selectedCurrency);
  };

  return [currency, selectCurrency];
}
